import Vue from 'vue'

const getDefaultTestMode = (env) => {
  switch (env) {
    case 'development':
      return true
    case 'production':
      return false
    case 'game':
      return false
    case 'customTest':
      return true
    default:
      return false
  }
}

const EnvironmentHelper = {
  install (Vue) {
    const env = process.env.NODE_ENV
    const envSettings = {
      current: env,
      isTestMode: getDefaultTestMode(env)
    }

    Vue.getEnvironmentName = function () {
      return envSettings.current
    }
    Vue.isTestMode = function () {
      return envSettings.isTestMode
    }
    Vue.changeTestMode = function (value) {
      envSettings.isTestMode = value
    }
  }
}

Vue.use(EnvironmentHelper)

// export default EnvironmentHelper
